export default __webpack_public_path__ + "assets/ico_tip-fffd9beb.svg";